import GTManager from '@widgets/gtm';
import SentryManager from '@widgets/sentry-manager';
import { store } from 'store';
import { authConstants } from '@constants/user';
import { accountConstants } from '@constants/account';
import { authService, hubService } from '@services';

export const authActions = {
    setUserFail,
    logout,
    getCurrentUser,
    resetStore,
    setUser,
    setUserLoading,
};

const success = user => ({ type: authConstants.LOGIN_SUCCESS, user });

const failure = error => ({ type: authConstants.LOGIN_FAILURE, error });

function getCurrentUser() {
    return dispatch => {
        return authService.getCurrentUser().then(
            user => {
                const userFromLS = JSON.parse(localStorage.getItem('user'));
                localStorage.setItem(
                    'user',
                    JSON.stringify({ ...userFromLS, ...user, token: user?.token || userFromLS?.token }),
                );
                SentryManager.setUser(user);
                dispatch(success(user));
            },
            () => dispatch(failure()),
        );
    };
}

function logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('company');
    GTManager.push('user-data-updated');
    // INFO: stop hub connection
    hubService.stopHub();
    SentryManager.clearUser();
    store.dispatch(resetStore());
    accountConstants.BILLING_EXPIRED = 0;
    return { type: authConstants.LOGOUT };
}

function resetStore() {
    return { type: authConstants.CLEAR_STORE };
}

function setUser(user) {
    return { type: authConstants.SET_USER, user };
}

function setUserFail() {
    return { type: authConstants.LOGIN_FAILURE };
}

function setUserLoading(isLoading) {
    return { type: authConstants.SET_USER_LOADING, payload: isLoading };
}
